<template>
  <div
    class="fshr-favorites-button"
    :class="{ 'fshr-favorites-button--isActive': this.isFavorite }"
    @click.stop="onToggle"
  >
    <span
      class="fshr-favorites-button__icon"
      :class="[this.isFavorite ? 'icon-fischer-67' : 'icon-heart-otlines']"
    />
  </div>
</template>

<script>
/**
 * @emits onToggle when favorite button changes
 */
export default {
  name: "favorites-button",
  props: {
    /**
     * define state of the button
     */
    isFavorite: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit("favoriteChange", !this.isFavorite);
    },
  },
};
</script>
